import { useCallback, useState } from "react";
import { salesService } from "../../api_client";
import { showErrorToast, showSuccessToast } from "../../../utils/toasts";

export function useRenewQuotation() {
    const [ isLoading, setIsLoading ] = useState(false);

    const renewQuotation = useCallback(
        async (id: number): Promise<boolean> => {
            setIsLoading(true);
            try {
                await salesService.renewQuotation(id);
                showSuccessToast("Quotation renewed successfully!");
                return true;
            } catch (error) {
                console.error("Failed to renew quotation:", error);
                showErrorToast("Failed to renew quotation. Please try again.");
                return false;
            } finally {
                setIsLoading(false);
            }
        },
        []
    );

    return { renewQuotation, isLoading };
}

